import SizedQuantity from './SizedQuantity'
export default SizedQuantity
